import React from "react";
import Functions from "./index.function";
const AgencyCom = (props) => {
  const { width, handleClick } = Functions(props);
  return (
    <div
      style={{
        backgroundColor: props.bgColor,
        width:
          width < 500
            ? width / 3 - 5
            : width === 768
            ? width / 4 - 80
            : width === 1024
            ? width / 5 - 10
            : width / 6 - 20,
      }}
      onClick={handleClick}
    >
      <img
        src={props.image}
        className={`rounded-full lg:h-36 xl:h-48`}
        alt={props.title}
      />
    </div>
  );
};
export default AgencyCom;
